<template>
  <div>
    <view-document></view-document>
  </div>
</template>

<script>

import ViewDocument from "@/components/backend/ViewDocument";



export default {
  name:'approve-view',

  components:{
    ViewDocument
  },

  data() {

    return{

    }
  }
}
</script>

<style scoped>

</style>
